<template>
	<div>
		<el-dialog :title="$t('pay.title')" :visible="isShowPay" class="pay-dialog" width="90%" top="2vh" append-to-body :before-close="payClose" style="margin: 0 auto">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane :label="$t('pay.title')" name="first">
					<el-form :model="payorder" ref="payorder" :inline="true" label-width="200px" class="demo-shopform" border>
						<el-form-item :label="$t('purchase.tablelist[0]')" prop="num">
							<div style="width: 200px">{{ payorder.num }}</div>
						</el-form-item>

						<el-form-item :label="$t('financial.tablelist[0]')" prop="purclass">
							<div style="width: 200px">{{ payorder.purclass }}</div>
						</el-form-item>

						<el-form-item :label="$t('pay.name[13]')" prop="apNum"><el-input v-model="payorder.apNum" disabled></el-input></el-form-item>

						<el-form-item :label="$t('purchase.tablelist[2]')" prop="fullname"><el-input v-model="payorder.fullname" disabled></el-input></el-form-item>

						<el-form-item :label="$t('empfile.tablename[5]')" prop="tel"><el-input v-model="payorder.tel" disabled></el-input></el-form-item>

						<el-form-item :label="$t('purchase.tablelist[17]')" v-if="false"><el-input v-model="payorder.VatRate" type="number" disabled></el-input></el-form-item>

						<el-form-item :label="$t('pay.name[11]')"><el-input v-model="payorder.Tax" disabled></el-input></el-form-item>

						<el-form-item :label="$t('pay.name[12]')"><el-input v-model="payorder.totalAmount" disabled></el-input></el-form-item>
						<!-- <el-form-item :label="$t('purchase.tablelist[18]')"><el-input v-model="payorder.Tax + payorder.money" disabled></el-input></el-form-item> -->

						<el-form-item :label="$t('pay.name[10]')" prop="money">
							<el-input v-model="payorder.money" :disabled="isLookb == true || payorder.isUseDetail"></el-input>
						</el-form-item>

						<el-form-item :label="$t('supplier.dialog[16]')" prop="shortEng"><el-input v-model="payorder.shortEng" disabled></el-input></el-form-item>

						<el-form-item :label="$t('purchase.tablelist[5]')" prop="paytype" v-if="false"><el-input v-model="payorder.paytype" disabled></el-input></el-form-item>

						<el-form-item :label="$t('pay.name[8]')" prop="Invoice">
							<el-input v-model="payorder.Invoice" :disabled="isLookb == true"></el-input>
							<!-- <el-input v-model="payorder.Invoice" :disabled="true"></el-input> -->
						</el-form-item>

						<!-- <el-form-item :label="$t('pay.name[9]')" prop="VoucherNo">
							<el-input v-model="payorder.VoucherNo" :disabled="isLookb == true"></el-input>
						</el-form-item> -->
						
						<el-form-item :label="$t('pay.name[1]')" prop="InvoiceDate">
							<el-date-picker type="date" v-model="payorder.InvoiceDate" style="width: 200px" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :disabled="isLookb == true"></el-date-picker>
						</el-form-item>

						<el-form-item :label="$t('invoice.Add[10]')" prop="paydt">
							<!-- <el-input type="date" v-model="payorder.paydt" style="width: 200px;" :disabled="true"></el-input> -->
							<el-date-picker type="date" v-model="payorder.paydt" style="width: 200px" value-format="yyyy-MM-dd" format="yyyy-MM-dd" disabled></el-date-picker>
						</el-form-item>

						<el-form-item :label="$t('pay.name[0]')" prop="payer" v-if="false"><el-input v-model="payorder.payer" disabled></el-input></el-form-item>

						<el-form-item :label="$t('pay.name[2]')" prop="payState"><el-input v-model="payorder.ispaystate" disabled></el-input></el-form-item>

						<el-form-item :label="$t('financial.tablelist[21]')" prop="cardid" v-if="false"><el-input v-model="payorder.cardid" disabled></el-input></el-form-item>

						<el-form-item :label="$t('subscribe.labellist[2]')" prop="applydt"><el-input v-model="payorder.applydt" disabled></el-input></el-form-item>

						<el-form-item v-if="purchaseOrder !== null && purchaseOrder !== undefined" :label="$t('purchase.tablelist[4]')" prop="">
							<el-input v-model="purchaseOrder.discount" disabled></el-input>
						</el-form-item>

						<el-form-item :label="$t('supplier.dialog[7]')" prop="address"><el-input v-model="payorder.address" disabled style="width: 575px"></el-input></el-form-item>

						<el-form-item :label="$t('purchaseOrder.purchasetabs[1]')" prop="explain" class="address">
							<el-input v-model="payorder.explain" :disabled="isLookb == true" type="textarea" style="width: 100%" :autosize="{ minRows: 2, maxRows: 3 }"></el-input>
						</el-form-item>

						<el-form-item :label="$t('subscribe.labellist[4]')" prop="explain" class="address">
							<el-input
								v-model="purchaseOrder.explain"
								:disabled="isLookb == true"
								type="textarea"
								style="width: 100%"
								:autosize="{ minRows: 2, maxRows: 3 }"
							></el-input>
						</el-form-item>

						<el-form-item :label="$t('pay.isUseDetail')" prop="isUseDetail">
							<el-checkbox v-model="payorder.isUseDetail" @change="changeRecordDetailItem" :disabled="isLookb == true"></el-checkbox>
						</el-form-item>

						<el-form-item label="" class="formtable" style="width: 100%" v-if="purchaseOrder != null">
							<el-table
								ref="detailTable"
								:empty-text="$t('header.tableEmpty')"
								stripe
								border
								row-key="purchaseOrder"
								:data="payorder.itemList"
								style="width: 100%"
								@selection-change="changeItemSelection"
							>
								<el-table-column>
									<template slot="header" slot-scope="scope">
										<div style="display: flex">
											<el-button type="primary" @click="exportCurrentItemList(scope)">{{ $t('GoodsList.filesout') }}</el-button>

											<select-excel :label="$t('subscribe.button[2]')" :before-upload="importUpdateCurrentItemList"></select-excel>
										</div>
									</template>

									<el-table-column type="selection" width="55" :reserve-selection="true" :selectable="checkboxChecking"></el-table-column>
									<el-table-column :label="$t('subscribe.labellist[9]')" width="100" prop="Goods.num" show-overflow-tooltip align="center"></el-table-column>
									<el-table-column :label="$t('pay.detailTableHeader[0]')" width="250" prop="name" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column :label="$t('pay.detailTableHeader[2]')" width="100" prop="baseQty" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column :label="$t('subscribe.labellist[12]')" prop="Goods.unit" width="110" show-overflow-tooltip align="center"></el-table-column>
									<el-table-column :label="$t('pay.detailTableHeader[3]')" width="150" prop="price" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column :label="$t('pay.detailTableHeader[4]')" width="130" prop="qty" align="center">
										<template slot-scope="scope">
											<el-input
												type="number"
												v-model="scope.row.qty"
												:disabled="!payorder.isUseDetail"
												style="width: 100%"
												min="0"
												:max="scope.row.baseQty"
												@input="changeItemQty"
											></el-input>
										</template>
									</el-table-column>
									<el-table-column :label="$t('pay.detailTableHeader[5]')" width="120" prop="VatRate" align="center" show-overflow-tooltip></el-table-column>
									<el-table-column
										:label="$t('pay.detailTableHeader[6]')"
										width="180"
										prop="Tax"
										align="center"
										show-overflow-tooltip
										:formatter="tableFormatter"
									></el-table-column>
									<el-table-column
										:label="$t('pay.detailTableHeader[7]')"
										width="180"
										prop="totalMoney"
										align="center"
										show-overflow-tooltip
										:formatter="tableFormatter"
									></el-table-column>
									<el-table-column
										:label="$t('pay.detailTableHeader[8]')"
										width="180"
										prop="totalAmount"
										align="center"
										show-overflow-tooltip
										:formatter="tableFormatter"
									></el-table-column>
								</el-table-column>
							</el-table>
						</el-form-item>

						<el-form-item style="display: flex; justify-content: end">
							<el-button type="primary" v-if="isLookb == false" @click="submitOrder">{{ $t('GoodsList.submitBtn') }}</el-button>
							<el-button type="primary" @click="auditOrder" v-if="isnotify == true && isLookb == true">{{ $t('audit.buttons[1]') }}</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>

				<el-tab-pane :label="$t('pay.title2')" name="second">
					<el-table :empty-text="$t('header.tableEmpty')" stripe border :data="purchaseOrder.GoodsList" style="width: 100%" row-key="GoodsList">
						<el-table-column>
							<template slot="header" slot-scope="scope">
								<div style="display: flex">
									<el-button type="warning" @click="updateCurrentPO">{{ $t('pay.button[0]') }}</el-button>
									<el-button type="primary" @click="filesOut(scope)">{{ $t('GoodsList.filesout') }}</el-button>
								</div>
							</template>

							<el-table-column :label="$t('subscribe.labellist[9]')" width="110" prop="Goods.num" show-overflow-tooltip align="center"></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[10]')" width="270" prop="Goods.name" show-overflow-tooltip align="center"></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[17]')" width="110" prop="BaseCount" align="center"></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[11]')" width="110" prop="count" align="center">
								<template slot-scope="scope">
									<el-input type="number" v-model="scope.row.count" disabled style="width: 100%" min="0"></el-input>
								</template>
							</el-table-column>

							<el-table-column
								:label="$t('purchase.tablelist[24]')"
								width="110"
								prop="price"
								align="center"
								:formatter="tableFormatter"
								show-overflow-tooltip
							></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[19]')" width="120" prop="requestReason" show-overflow-tooltip>
								<template slot-scope="scope">
									<div>{{ scope.row.requestReason }}</div>
								</template>
							</el-table-column>

							<el-table-column :label="$t('subscribe.labellist[12]')" width="110" prop="Goods.unit" show-overflow-tooltip align="center"></el-table-column>

							<el-table-column
								:label="$t('GoodsList.dialog[28]')"
								prop="price"
								width="110"
								:formatter="tableFormatter"
								show-overflow-tooltip
								align="center"
							></el-table-column>

							<el-table-column :label="$t('purchase.tablelist[17]')" width="110" prop="VatRate" show-overflow-tooltip align="center">
								<template slot-scope="scope">
									<el-input type="number" v-model="scope.row.VatRate" style="width: 60px !important" min="0" max="20" :disabled="isLookb == true"></el-input>
								</template>
							</el-table-column>

							<el-table-column
								:formatter="tableFormatter"
								:label="$t('purchase.tablelist[21]')"
								width="110"
								prop="10"
								show-overflow-tooltip
								align="center"
							></el-table-column>

							<el-table-column align="center" :label="$t('GoodsList.dialog[21]')" width="120" prop="Goods.NeedInspect" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('purchase.tablelist[19]')" prop="PQInfo" width="120" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('purchase.tablelist[20]')" width="110" prop="FromDepart" show-overflow-tooltip></el-table-column>

							<!-- <el-table-column align="center" :label="$t('GoodsList.dialog[23]')" prop="Goods.AccountNO" show-overflow-tooltip></el-table-column> -->

							<!-- <el-table-column align="center" :label="$t('GoodsList.dialog[27]')" prop="Goods.explain" show-overflow-tooltip></el-table-column> -->

							<!-- 123456789 -->
							<!-- <el-table-column align="center" :label="$t('pay.name[8]')" prop="Goods.Invoice" show-overflow-tooltip></el-table-column> -->

							<!-- <el-table-column align="center" :label="$t('pay.name[1]')" prop="Goods.paydt" show-overflow-tooltip></el-table-column> -->
						</el-table-column>
					</el-table>
				</el-tab-pane>

				<el-tab-pane :label="$t('pay.title1')" name="third">
					<el-table :empty-text="$t('header.tableEmpty')" stripe border :data="detailItemList" style="width: 100%" row-key="detailItemList">
						<el-table-column>
							<template slot="header" slot-scope="scope">
								<div style="display: flex">
									<el-button type="primary" @click="filesOut1(scope)">{{ $t('GoodsList.filesout') }}</el-button>
								</div>
							</template>

							<el-table-column
								:label="$t('subscribe.labellist[9]')"
								width="100"
								prop="ItemCode"
								key="ItemCode"
								show-overflow-tooltip
								align="center"
							></el-table-column>

							<el-table-column
								:label="$t('subscribe.labellist[10]')"
								width="100"
								prop="ItemName"
								key="ItemName"
								show-overflow-tooltip
								align="center"
							></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[36]')" width="120" prop="LocalLanguage" show-overflow-tooltip align="center"></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[11]')" width="100" prop="Qty" show-overflow-tooltip align="center"></el-table-column>

							<el-table-column
								:label="$t('subscribe.labellist[45]')"
								width="100"
								prop="UnitPrice"
								align="center"
								:formatter="tableFormatter"
								show-overflow-tooltip
							></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[12]')" width="90" prop="Unit" show-overflow-tooltip align="center"></el-table-column>

							<el-table-column
								:label="$t('subscribe.labellist[46]')"
								prop="TotalAmount"
								:formatter="tableFormatter"
								show-overflow-tooltip
								align="center"
							></el-table-column>

							<el-table-column :label="$t('subscribe.labellist[37]')" width="90" prop="Tax" show-overflow-tooltip align="center"></el-table-column>

							<el-table-column
								:formatter="tableFormatter"
								:label="$t('subscribe.labellist[38]')"
								prop="TotalTax"
								show-overflow-tooltip
								align="center"
							></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[39]')" width="120" prop="purchaseType" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[34]')" width="120" prop="AccountNO" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[33]')" width="120" prop="AccountName" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[40]')" width="120" prop="Department" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[41]')" prop="PONum" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[42]')" width="130" prop="CreatePODate" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[43]')" width="120" prop="RequestNO" show-overflow-tooltip></el-table-column>

							<el-table-column align="center" :label="$t('subscribe.labellist[44]')" width="120" prop="RequestDate" show-overflow-tooltip></el-table-column>
						</el-table-column>
					</el-table>
				</el-tab-pane>

				<el-tab-pane :label="$t('pay.name[5]') + ' ' + $t('purchaseOrder.purchasetabs[2]')" name="four">
					<el-upload
						style="display: flex; width: auto"
						class="uploadc"
						:action="uploadpurchURL"
						:data="uploadData"
						:show-file-list="false"
						:on-remove="purchChange"
						:on-preview="clickFiles"
						:on-success="purchSuccess"
						:before-remove="fileDelete"
						:disabled="isPurchb == false"
					>
						<div style="display: flex; justify-content: space-around; height: 100%">
							<div style="display: flex; justify-content: flex-start; align-items: center; flex-direction: column; margin-top: 20px">
								<el-button size="small" type="primary" v-if="isPurchb == true">{{ $t('GoodsList.dialog[11]') }}</el-button>
							</div>
							<div class="uploadTable" style="width: 65%; margin: auto 0; height: 100%; overflow: hidden; overflow-y: scroll">
								<el-table :empty-text="$t('header.tableEmpty')" :data="payorder.purchList" stripe :show-header="false" style="width: 100%">
									<el-table-column prop="filename">
										<template slot-scope="scope">
											<span style="margin-right: 10px; font-size: 15px">{{ scope.row.filename }}</span>
											<i class="el-icon-circle-check" style="color: #67c23a"></i>
										</template>
									</el-table-column>
									<el-table-column prop="download">
										<template slot-scope="scope">
											<el-link type="primary" icon="el-icon-download" style="font-size: 15px" @click.stop="clickFiles(scope.row)">
												{{ $t('GoodsList.dialog[12]') }}
											</el-link>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</el-upload>
				</el-tab-pane>

				<el-tab-pane :label="$t('pay.name[6]') + ' ' + $t('purchaseOrder.purchasetabs[2]')" name="five">
					<el-upload
						style="display: flex; width: auto"
						class="uploadc"
						:action="uploadfinancURL"
						:data="uploadData"
						:show-file-list="false"
						:on-remove="financChange"
						:on-preview="clickFiles"
						:on-success="financSuccess"
						:before-remove="fileDelete"
						:disabled="isPurchb == true"
					>
						<div style="display: flex; justify-content: space-around; height: 100%">
							<div style="display: flex; justify-content: flex-start; align-items: center; flex-direction: column; margin-top: 20px">
								<el-button size="small" type="primary" v-if="isPurchb == false">{{ $t('GoodsList.dialog[11]') }}</el-button>
							</div>
							<div class="uploadTable" style="width: 65%; margin: auto 0; height: 100%; overflow: hidden; overflow-y: scroll">
								<el-table :empty-text="$t('header.tableEmpty')" :data="payorder.financList" stripe :show-header="false" style="width: 100%">
									<el-table-column prop="filename">
										<template slot-scope="scope">
											<span style="margin-right: 10px; font-size: 15px">{{ scope.row.filename }}</span>
											<i class="el-icon-circle-check" style="color: #67c23a"></i>
										</template>
									</el-table-column>
									<el-table-column prop="download">
										<template slot-scope="scope">
											<el-link type="primary" icon="el-icon-download" style="font-size: 15px" @click.stop="clickFiles(scope.row)">
												{{ $t('GoodsList.dialog[12]') }}
											</el-link>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</el-upload>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import bus from '../bus';
import wmsApi from '@/request/wmsApi';
import financialApi from '@/request/financialApi';
import baseDataApi from '@/request/baseDataApi';
import xlsxTool from '@/utils/xlsxTool';
import SelectExcel from '@/components/common/SelectExcel';
import { cat } from 'shelljs';
export default {
	name: 'AddPaymentOrder',
	components: {
		SelectExcel
	},
	props: {
		purchaseOrder: {
			required: false,
			default: () => {},
			type: Object
		},
		detailItemList: {
			required: false,
			default: () => [],
			type: Array
		},
		payorder: {
			required: true,
			default: () => {},
			type: Object
		},
		isShowPay: {
			required: true,
			default: false,
			type: Boolean
		},
		isEditb: {
			required: false,
			default: false,
			type: Boolean
		},
		isLookb: {
			required: false,
			default: false,
			type: Boolean
		},
		isPurchb: {
			required: false,
			default: false,
			type: Boolean
		},
		isnotify: {
			required: false,
			default: false,
			type: Boolean
		},
		auditid: {
			required: false,
			default: 0,
			type: Number
		}
	},
	data() {
		return {
			base_name: '',
			base_deptname: '',
			activeName: 'first',
			uploadData: {},
			// purchList: [],
			purchID: [],
			// financList: [],
			financID: []
		};
	},
	mounted() {
		if (this.userData === null) return;

		this.base_name = this.userData.user;
		this.base_deptname = this.userData.deptname;
	},
	methods: {
		importUpdateCurrentItemList(excelFile) {
			try {
				this.$refs.detailTable.clearSelection();
				let loading = this.$loading(this.loadingOption);
				// console.warn(this.payorder.itemList);
				xlsxTool.onImportExcel(excelFile).then(async (recordList) => {
					recordList.forEach((record) => {
						// console.log('record->', record);
						if (record.itemNum && record.qty) {
							let findItem = this.payorder.itemList.find((match) => {
								return match.nid === parseInt(record.nid);
							});
							if (findItem != null && findItem.baseQty >= parseFloat(record.qty)) {
								findItem.qty = parseFloat(record.qty);
								this.$refs.detailTable.toggleRowSelection(findItem, true);
							}
						}
					});
				});
				// this.$nextTick(() => {
				// 	this.payorder.itemList.forEach(item => {
				// 		console.log('1111');
				// 		this.$refs.detailTable.toggleRowSelection(item, true);
				// 	});
				// });

				// this.changeItemQty();
				loading.close();
			} catch (ex) {
				console.log(ex);
			}
		},

		exportCurrentItemList(scope) {
			console.log(scope);
			let tmpArr = [];
			this.payorder.itemList.forEach((item) => {
				item.itemNum = item.Goods.num;
				tmpArr.push(item);
			});
			xlsxTool.exportFile(tmpArr, `AP Including Item Detail.xlsx`);
		},

		checkboxChecking(row, index) {
			console.log(row, index);
			return this.payorder.isUseDetail;
		},

		changeItemSelection(e) {
			this.payorder.itemList.forEach((item, index) => {
				let findObj = e.find((match) => {
					return match.Goods.num === item.Goods.num;
				});
				if (findObj === null || findObj === undefined) item.qty = 0;
				else {
					if (findObj.qty === 0) findObj.qty = findObj.baseQty;
				}
			});
			this.changeItemQty();
		},

		changeItemQty(e) {
			let totalPayAmount = 0;
			if (this.payorder.isUseDetail) {
				this.payorder.itemList.forEach((item) => {
					if (item.qty > 0) {
						// item.totalMoney = Math.round(item.price * item.qty, 2);
						// item.Tax = Math.round((item.totalMoney * item.VatRate) / 100, 2);
						// item.totalAmount = Math.round(item.totalMoney + item.Tax, 2);
						item.totalMoney = item.price * item.qty;
						item.Tax = (item.totalMoney * item.VatRate) / 100;
						item.totalAmount = item.totalMoney + item.Tax;
					} else {
						item.totalMoney = 0;
						item.Tax = 0;
						item.totalAmount = 0;
					}
					totalPayAmount += item.totalAmount;
				});
				if (Math.abs(this.payorder.totalAmount - totalPayAmount) < 3) {
					totalPayAmount = this.payorder.totalAmount;
				}
				this.payorder.money = Math.ceil(totalPayAmount, 2);
			}
		},

		changeRecordDetailItem(e) {
			console.log(e);
			if (e) {
			} else {
			}
		},

		filesOut(scope) {
			this.purchaseOrder.GoodsList.forEach((goodobj, index) => {
				goodobj.price = goodobj.price.replace('.', '');
				goodobj.totalAmount = goodobj.totalAmount.replace('.', '');
				goodobj.Tax = goodobj.Tax > 0 ? goodobj.Tax.replace('.', '') : goodobj.Tax;
			});
			xlsxTool.exportFile(this.purchaseOrder.GoodsList, 'PayOrderGoodsList.xlsx');
			this.purchaseOrder.GoodsList.shift();
		},

		filesOut1(scope) {
			// this.loading = true;
			// let searchRes = await wmsApi.GetGoodsList(this.token, this.keyword, this.nodeID, '1', '', 1, 999999);
			// this.loading = false;
			// if (searchRes.resultCode === 0) {
			// console.log(this.purchaseOrder.GoodsList);
			// console.log(this.purchaseOrder);
			this.detailItemList.forEach((goodobj, index) => {
				goodobj.TotalAmount = (goodobj.TotalAmount + '').replace('.', '');
				goodobj.UnitPrice = (goodobj.UnitPrice + '').replace('.', '');
				goodobj.Tax = goodobj.Tax > 0 ? (goodobj.Tax + '').replace('.', '') : goodobj.Tax;
				goodobj.TotalTax = goodobj.TotalTax > 0 ? (goodobj.TotalTax + '').replace('.', '') : goodobj.TotalTax;
			});
			// console.log(this.purchaseOrder);
			xlsxTool.exportFile(this.detailItemList, 'RequestDepartDetail.xlsx');
			this.detailItemList.shift();
			// console.log(this.purchaseOrder.GoodsList);
			// this.purchaseOrder.GoodsList
			// }
		},

		updateCurrentPO() {
			this.$confirm(this.$t('pay.tips[0]'), this.$t('header.tishi'), {
				confirmButtonText: this.$t('header.confirmButtonText'),
				cancelButtonText: this.$t('header.cancelButtonText'),
				type: 'warning'
			})
				.then(async () => {
					// console.log(this.purchaseOrder);
					let sucRes = await wmsApi.CreateOrEditPurchase(this.token, [this.purchaseOrder]);
					if (sucRes.resultCode === 0) {
						this.$message({
							message: sucRes.errMsg,
							type: 'success'
						});
						let PORes = await wmsApi.GetPurchaseInfo(this.token, this.purchaseOrder.id);
						this.$emit('update:purchaseOrder', PORes.data);
						// this.$emit('update:currentPurchaseOrder', PORes.data);
					}
				})
				.catch(() => {});
		},

		tableFormatter(row, column, cellValue, index) {
			// console.log(column.label, this.$t('purchase.tablelist[24]'));

			if (column.label === this.$t('GoodsList.dialog[4]') || column.label === this.$t('purchase.tablelist[24]')) {
				if (row.price) {
					row.price += '';
					if (!row.price.includes('.')) row.price += '.';
					return row.price
						.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
							return $1 + ',';
						})
						.replace(/\.$/, '');
				}
			} else if (column.label == this.$t('GoodsList.dialog[28]')) {
				if (row.totalAmount) {
					row.totalAmount += '';
					if (!row.totalAmount.includes('.')) row.totalAmount += '.';
					return row.totalAmount
						.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
							return $1 + ',';
						})
						.replace(/\.$/, '');
				}
			} else if (column.label == this.$t('purchase.tablelist[21]')) {
				if (row.Tax) {
					row.Tax += '';
					if (!row.Tax.includes('.')) row.Tax += '.';
					return row.Tax.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					}).replace(/\.$/, '');
				}
			} else if (column.label === this.$t('subscribe.labellist[45]')) {
				if (row.UnitPrice) {
					row.UnitPrice += '';
					if (!row.UnitPrice.includes('.')) row.UnitPrice += '.';
					return row.UnitPrice.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					}).replace(/\.$/, '');
				}
			} else if (column.label == this.$t('subscribe.labellist[46]')) {
				if (row.TotalAmount) {
					row.TotalAmount += '';
					if (!row.TotalAmount.includes('.')) row.TotalAmount += '.';
					return row.TotalAmount.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					}).replace(/\.$/, '');
				}
			} else if (column.label == this.$t('subscribe.labellist[38]')) {
				if (row.TotalTax) {
					row.TotalTax += '';
					if (!row.TotalTax.includes('.')) row.TotalTax += '.';
					return row.TotalTax.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					}).replace(/\.$/, '');
				}
			} else if (column.label == this.$t('pay.detailTableHeader[6]')) {
				if (row.Tax) {
					row.Tax += '';
					if (!row.Tax.includes('.')) row.Tax += '.';
					return row.Tax.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
						return $1 + ',';
					}).replace(/\.$/, '');
				}
			} else if (column.label == this.$t('pay.detailTableHeader[7]')) {
				if (row.totalMoney) {
					row.totalMoney += '';
					if (!row.totalMoney.includes('.')) row.totalMoney += '.';
					return row.totalMoney
						.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
							return $1 + ',';
						})
						.replace(/\.$/, '');
				}
			} else if (column.label == this.$t('pay.detailTableHeader[8]')) {
				if (row.totalAmount) {
					row.totalAmount += '';
					if (!row.totalAmount.includes('.')) row.totalAmount += '.';
					return row.totalAmount
						.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
							return $1 + ',';
						})
						.replace(/\.$/, '');
				}
			}

			return cellValue;
		},

		async submitOrder() {
			let objCopy = Object.assign({}, this.payorder);
			console.log(objCopy);
			if (this.isPurchb == true) {
				if (objCopy.purchList && objCopy.purchList.length > 0) {
					objCopy.purchList.forEach((purchobj) => {
						this.purchID.push(purchobj.id);
						objCopy.attach = this.purchID;
					});
				}
			}
			if (this.isPurchb == false) {
				if (objCopy.financList && objCopy.financList.length > 0) {
					objCopy.financList.forEach((financobj) => {
						this.financID.push(financobj.id);
						objCopy.attach = this.financID;
					});
				}
			}

			if (isNaN(objCopy.money)) {
				objCopy.money = objCopy.money.replace(/,/g, '');
				objCopy.money = Number(objCopy.money);
			}

			if (objCopy.money <= 0) {
				this.$message({
					message: this.$t('pay.money'),
					type: 'warning'
				});
				return;
			}

			// if (!objCopy.InvoiceDate) {
			// 	this.$message({
			// 		message: 'Please Input Invoice Date',
			// 		type: 'warning'
			// 	});
			// 	return;
			// }

			if (!objCopy.isUseDetail) {
				delete objCopy.itemList;
			}
			
			let loading = this.$loading(this.loadingOption);
			let submitRes = await financialApi.CreateOrEditApplicationPay(this.token, objCopy);
			loading.close();
			
			if (submitRes.resultCode === 0) {
				this.activeName = 'first';
				this.purchID = [];
				this.financID = [];
				// this.$emit('closePay');

				this.$confirm(submitRes.errMsg, this.$t('header.tishi'), {
					showCancelButton: false,
					type: 'success'
				})
					.then(() => {
						this.$emit('closePay');
					})
					.catch(() => {});
			} else {
				this.$confirm(submitRes.errMsg, this.$t('header.tishi'), {
					showCancelButton: false,
					type: 'warning'
				})
					.then(() => {})
					.catch(() => {});
			}
		},

		payClose(done) {
			this.$confirm(this.$t('header.confirm'), this.$t('header.tishi'), {
				confirmButtonText: this.$t('header.confirmButtonText'),
				cancelButtonText: this.$t('header.cancelButtonText'),
				type: 'warning'
			})
				.then(() => {
					this.activeName = 'first';
					this.purchID = [];
					this.financID = [];
					this.$emit('closePay');
					done();
				})
				.catch(() => {});
		},

		purchSuccess(res, file, fileList) {
			this.payorder.purchList.push(file.response.data);
			this.payorder.purchList = this.payorder.purchList;
		},

		purchChange(file, fileList) {
			this.payorder.purchList = fileList.slice(-3);
		},

		financSuccess(res, file, fileList) {
			this.payorder.financList.push(file.response.data);
			this.payorder.financList = this.payorder.financList;
		},

		financChange(file, fileList) {
			this.payorder.financList = fileList.slice(-3);
		},

		clickFiles(file) {
			let downUrl = wmsApi.GetDownloadUrl(this.token, file.id);
			window.open(downUrl);
		},

		fileDelete(file, fileList) {
			return false;
		},

		async auditOrder() {
			let appid = [];
			appid.push(this.auditid);
			let submitRes = await wmsApi.ApprovalRequest(this.token, appid, '', 1);

			if (submitRes.resultCode === 0) {
				this.$message({
					message: this.$t('GoodsList.submitBtn') + ' ' + this.$t('GoodsList.msg[0]'),
					type: 'success'
				});
				this.$emit('closePay');
			} else {
				this.$confirm(submitRes.errMsg, this.$t('header.tishi'), {
					confirmButtonText: this.$t('header.confirmButtonText'),
					cancelButtonText: this.$t('header.cancelButtonText'),
					type: 'warning'
				});
			}
		}
	},
	computed: mapState({
		userData: (state) => state.user.userData,
		token: (state) => state.user.token,
		loadingOption: (state) => state.system.loadingOption,
		uploadpurchURL() {
			return wmsApi.GetUploadUrl(this.token, this.payorder.id ? this.payorder.id : 0, 'supplierreceipt');
		},
		uploadfinancURL() {
			return wmsApi.GetUploadUrl(this.token, this.payorder.id ? this.payorder.id : 0, 'certificatepay');
		}
	})
};
</script>

<style>
.pay-dialog .el-dialog {
	margin-top: 5vh !important;
	height: auto !important;
}

.pay-dialog::-webkit-scrollbar {
	width: 0 !important;
}

.el-input.is-disabled .el-input__inner {
	color: #000000;
}

.picsCard .el-carousel__container {
	height: 600px;
}

.address {
	width: 100%;
}

.address .el-form-item__content {
	width: 570px;
}

.uploadc .el-upload--text {
	width: 100%;
	margin-right: 0;
	height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PurchasingManagement/AddPaymentOrder.vue